<template>
  <div class="app-container">
    <!-- 查询开始 -->
    <div>
      <!--高级搜索输入框开始 -->
      <div v-if="show">
         <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="创建时间">
              <el-date-picker
                v-model="timeValue"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions2"
                value-format="timestamp"
                :default-time="['00:00:00', '23:59:59']"
              ></el-date-picker>
            </el-form-item>
          </el-form>
      </div>
      <!--高级搜索输入框结束 -->
      <!-- 普通搜索 -->
      <div class="searchheader">
         <el-form :inline="true"  class="demo-form-inline">
           <el-form-item label="渠道名称">
             <el-input v-model="nameValue" placeholder="请输入渠道名称"></el-input>
           </el-form-item>
           <el-form-item label="商户号">
             <el-input v-model="searchId" placeholder="请输入商户号"></el-input>
           </el-form-item>
           <el-form-item label="状态">
             <el-select v-model="stateValue" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
           </el-form-item>
           <el-form-item label="审核状态">
             <el-select v-model="examined" placeholder="请选择">
                <el-option
                  v-for="item in options2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
           </el-form-item>
           <el-form-item>
            <el-button type="primary" icon="el-icon-search" plain round @click="search">搜索</el-button>
               <el-button
                @click="show = !show"
                plain
                type="primary"
                :icon="show ? 'el-icon-zoom-out':'el-icon-zoom-in'"
                round
                style="border:0;"
              >高级搜索</el-button>
           </el-form-item>
        </el-form>
        <div><el-button type="primary" round plain @click="addAlipay" icon="el-icon-circle-plus">创建</el-button></div>
        </div>
      <!-- 普通搜索结束 -->
      <!-- 弹框 -->
      <el-dialog title="创建云纵收款" :visible.sync="dialogFormVisible" width="25%">
        <el-form :model="addWechatList">
          <el-form-item
            label="名称"
            :label-width="formLabelWidth"
            prop="mchName"
            :rules="[{ required: true, message: '名称不能为空', trigger: 'blur' }]"
          >
            <el-input v-model="addWechatList.mchName" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item
            label="服务商"
            :label-width="formLabelWidth"
            v-show="this.$store.state.user.level===1"
            prop="projectValue"
            :rules="[{ required: true, message: '请选择服务商', trigger: 'change' }]"
          >
            <el-select
              v-model="addWechatList.projectValue"
              placeholder="请输入关键字查询"
              style="width:100%;"
               clearable
              filterable remote :remote-method="remoteMethod"
              @change="getShop(addWechatList.projectValue)"
            >
              <el-option
                v-for="item in projectList"
                :key="item.id"
                :label="item.label"
                :value="item.projectName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="商户"
            :label-width="formLabelWidth"
            v-show="this.$store.state.user.level !==3"
            prop="shopValue"
            :rules="[{ required: true, message: '请选择商户', trigger: 'change' }]"
          >
            <el-select v-model="addWechatList.shopValue"  filterable remote :remote-method="remoteShop" placeholder="请输入关键字查询" style="width:100%;">
              <el-option
                v-for="item in shopList"
                :key="item.id"
                :label="item.label"
                :value="item.shopName"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="addSureWechat">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 查询结束 -->
    <!-- 表格开始 -->
    <div>
      <el-table
        border
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        :data="tableDataList"
        style="width: 100%;"
        :height="this.show ?640:700"
        :row-class-name="tableRowClassName"
      >
       <el-table-column type="expand">
            <template slot-scope="scope">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-form-item label="创建时间">
                  <span>{{ scope.row.createTimes }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
        <el-table-column label="序号" width="60">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.num }}</span>
          </template>
        </el-table-column>
        <el-table-column label="渠道名称">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.mchName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="所属商户">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.shopTbMap }}</span>
          </template>
        </el-table-column>
        <el-table-column label="停车场ID">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.subMchId }}</span>
          </template>
        </el-table-column>
        <el-table-column label="商户ID">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.yzMchId }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.state }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否审核" width="100">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.examined }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="250" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain @click="DataEdit(scope.row)">编辑</el-button>
            <el-button
              size="mini"
              type="warning"
              plain
              @click="SwitchState(scope.row)"
            >{{scope.row.Disable}}</el-button>
            <el-button size="mini" plain type="success" @click="Verification(scope.row)">支付验证</el-button>
            <el-button size="mini" type="success" plain @click="searchMoney(scope.row)">打款查询</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 删除成功弹窗开始 -->
      <el-dialog title="删除" top="30vh" :visible.sync="dialogVisibleDel" width="15%">
        <span style="font-size:20px;">你确定要删除此条信息？请继续！</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleDel = false">取 消</el-button>
          <el-button type="primary" @click="SureDel">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 删除成功弹窗结束 -->
      <!-- 编辑开始 -->
      <el-dialog title="编辑" :visible.sync="DataEdits" width="25%">
        <el-form :model="alipayList">
          <el-form-item
            label="名称"
            :label-width="LabelWidth"
            prop="mchName"
            :rules="[{ required: true, message: '名称不能为空', trigger: 'blur' }]"
          >
            <el-input v-model="alipayList.mchName" auto-complete="off" style="width:93%"></el-input>
          </el-form-item>
          <el-form-item label="停车场ID" :label-width="LabelWidth">
            <el-input v-model="alipayList.subMchId" auto-complete="off" style="width:93%"></el-input>
          </el-form-item>
          <el-form-item label="商户ID" :label-width="LabelWidth">
            <el-input v-model="alipayList.yzMchId" auto-complete="off" style="width:93%"></el-input>
          </el-form-item>
          <el-form-item label="审核状态" :label-width="LabelWidth">
            <el-select
              v-model="alipayList.examined"
              placeholder="请选择"
              style="width:100%"
              :disabled="this.$store.state.user.level==3?true:false"
            >
              <el-option
                v-for="item in examinedData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="DataEdits = false">取 消</el-button>
          <el-button type="primary" @click="DetermineEdit">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 编辑结束 -->
      <!-- 支付验证弹框开始 -->
      <el-dialog title="支付验证" :visible.sync="payEdits" top="15%" width="20%" center @close="closes">
        <div id="payqrcodes" ref="payqrcodes"></div>
        <el-form :model="tradeId">
          <div class="payMoney">
            请用支付宝或微信扫码支付
            <span>￥ {{payTotal}}</span>元
          </div>
          <el-form-item label="流水号" :label-width="formLabelWidth_02">
            <el-input v-model="tradeId.tradeId" auto-complete="off" style="width:93%"></el-input>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 支付验证弹框结束 -->
    </div>
    <!-- 表格结束 -->
    <el-dialog title="打款查询" :visible.sync="dialogVisible" width="50%">
      <el-form ref="formMoney" :model="formMoney" label-width="80px">
        <el-form-item label="查询时间">
          <el-date-picker
            v-model="formMoney.time"
            type="date"
            value-format="timestamp"
            placeholder="选择日期"
            :picker-options="pickerOptions"
            style="width:100%"
          ></el-date-picker>
        </el-form-item>
        <div>
          <el-table :data="MoneyRecord">
            <el-table-column property="bank_holder" label="开户人"></el-table-column>
            <el-table-column property="bank_account" label="银行账号"></el-table-column>
            <el-table-column property="amount" label="打款金额"></el-table-column>
            <el-table-column property="fee" label="手续费"></el-table-column>
            <el-table-column property="sett_type" label="结算类型"></el-table-column>
            <el-table-column property="sett_date" label="结算日期"></el-table-column>
            <el-table-column property="remark" label="打款描述"></el-table-column>
            <el-table-column property="state" label="状态"></el-table-column>
          </el-table>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible=false">取 消</el-button>
        <el-button type="primary" @click="confirmSearch">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 分页开始 -->
    <div style="text-align:right">
      <Paging :totalSize="totalSize" :getMethods="getAlipay" />
    </div>
    <!-- 分页结束 -->
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import Paging from "../../components/Paging/Paging.vue";
import { getToken } from "../../utils/auth.js";
import AlipayDetails from "../components/details/alipayDetails.vue";
export default {
  components: {
    Paging,
    AlipayDetails
  },
  data() {
    return {
      loading:true,
      // 搜索框
      receivablesShow: false,
      input: "", //高级查询value值
      options: [
        //状态值
        {
          value: "1",
          label: "可用"
        },
        {
          value: "0",
          label: "禁用"
        },
        {
          value: "",
          label: "无"
        }
      ],
      options2: [
        //是否授权搜索框
        {
          value: "1",
          label: "审核通过"
        },
        {
          value: "0",
          label: "审核中"
        },
        {
          value: "-1",
          label: "未审核"
        },
        {
          value: "",
          label: "无"
        }
      ],
      authorization: [
        {
          value: "1",
          label: "是"
        },
        {
          value: "0",
          label: "否"
        }
      ],
      examinedData: [
        {
          value: -1,
          label: "未审核"
        },
        {
          value: 0,
          label: "审核中"
        },
        {
          value: 1,
          label: "审核通过" //审核通过
        }
      ],
      // 日期选择开始
      pickerOptions2: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() >= Date.now();
        }
      },
      timeValue:null, //微信选中的日期
      searchId: "", //搜索框商户号
      nameValue: "", //搜索框商户名
      examined: "", //是否审核value值
      stateValue: "", //状态搜索框
      searchInput: "", //编号
      dialogFormVisible: false, //弹框值
      formLabelWidth: "80px", //弹框输入框宽度
      formLabelWidth_02: "60px",
      LabelWidth: "100px", //弹框输入框宽度
      form: {
        //弹框表单
        projectName: "",
        phone: "",
        remark: "",
        address: ""
      },

      receivablesShow: true, //支付方式显示控制
      show: false,
      tableDataList: [],
      dialogVisibleDel: false, //删除弹窗
      tabelData: {}, //删除数据
      DataEdits: false, //编辑弹窗
      alipayList: {}, //编辑数据
      Tabledata: false, //资料补全
      CompletionMan: {}, //资料补全数据
      SubmitData: [],
      fileList: [], //上传文件列表
      fileInput: "", //上传文件输入框value
      headers: {
        //请求头token
        token: getToken().Token
      },

      projectList: [], //所有工程商
     
      shopList: [], //工程商下的商户
     
      addWechatList: { mchName: "", projectValue: "", shopValue: "" }, //创建数据
      totalSize: 0, //总条数
      DataDetail: false, //详情弹框value
      alipayData: {}, //支付宝点击的目标数据
      applyAliTb: {}, //进件数据
      pageDatalist: {},
      applyDescs: {}, //查询字段

      centerDialogVisible: false, //二维码弹框

      payTotal: 0, //支付金额
      payEdits: false, //支付验证弹框
      tradeId: { tradeId: "" }, //流水号

      dialogVisible: false, //打款查询弹框
      serachMoneyObj: {}, //需要查询打款的
      formMoney: { time: "" },

      MoneyRecord: [], //查询的打款记录

      stateAll:{
         'FAIL':'打款失败',
         'ONGOING':'打款中',
         'SUCCESS':'打款成功',
         'REFUND':'打款退票',
         'FROZEN':'冻结出款'    
      },

      queryProjectId:''
    };
  },
  computed: {
    uploadData() {
      //文件上传数据
      return {
        projectId: this.CompletionMan.projectContractorId,
        shopId: this.CompletionMan.shopId,
        remark: this.fileInput
      };
    }
  },
  methods: {
    // 获取订单
    getAlipay(pageData) {
      this.pageDatalist = { ...pageData };
      // 时间转换
      let datalists = {
            pageConfig: {
            orderType: "desc",
            pageSize: this.pageDatalist.pageSize,
            orderField: "id",
            pageNum: this.pageDatalist.pageNum
          },
          baseBean:{
            state: this.stateValue,
            shopId: this.searchId,
            examined: this.examined
          }
      };
      // 判断有没有进行高级搜索，有就传入对应的时间，没有就不传
      if (this.timeValue !== null) {
        datalists.searchBeans= [
            //高级查询条件
            {
              fieldName: "createTime", //字段
              startValue: this.timeValue[0]/1000, //值
              endValue: this.timeValue[1]/1000,
              operator: "BETWEEN" //大于等于
            },
            {
              fieldName: "state", //字段
              startValue: "0", //值
              operator: "GREATER_THAN_AND_EQUAL" //大于等于
            }
          ];
      } else {
        if (this.nameValue !== "") {
          datalists.searchBeans= [
              //高级查询条件
              {
                fieldName: "state", //字段
                startValue: "0", //值
                operator: "GREATER_THAN_AND_EQUAL" //大于等于
              },
              {
                fieldName: "mchName", //查询字段
                basicValue: this.nameValue, //值
                operator: "LIKE" //模糊查询
              }
            ];
        } else {
          datalists.searchBeans= [
              //高级查询条件
              {
                fieldName: "state", //字段
                startValue: "0", //值
                operator: "GREATER_THAN_AND_EQUAL" //大于等于
              }
            ];
        }
        if (this.searchId !== "") {
          datalists.searchBeans= [
              //高级查询条件
              {
                fieldName: "state", //字段
                startValue: "0", //值
                operator: "GREATER_THAN_AND_EQUAL" //大于等于
              }
            ]
        }
      }
      this.$axios.post("/mchyz/query", datalists).then(res => {
        this.loading=false;
        let datalist = res.data.mchYzTbPage; //返回数据
        this.totalSize = res.data.count;
        let number =
          (this.pageDatalist.pageNum - 1) * this.pageDatalist.pageSize; //分页时编号计算
        datalist.map(item => {
          number++;
          item.num = number;
          item.createTimes = this.getTiem(item.createTime);
          item.shopTbMap = res.data.shopTbMap[item.shopId];
          if (item.state === 1) {
            item.state = "可用";
            item.Disable = "禁用";
          } else if (item.state === 0) {
            item.state = "禁用";
            item.Disable = "启用";
          } else {
            item.state = "删除";
          }
          if (item.examined === -1) {
            item.examined = "未审核";
          } else if (item.examined === 0) {
            item.examined = "审核中";
          } else {
            item.examined = "审核通过";
          }
          return item;
        });
        this.tableDataList = datalist;
      });
    },
    // 搜索
    search() {
      this.getAlipay(this.pageDatalist);
    },
    remoteMethod(inputData){
      inputData!=='' && this.searchMerchant(inputData)
    },
    searchMerchant(inputData){
      // 获取工程商
      this.$axios.get("/projectContractor/queryAll",{params:{projectName:inputData}}).then(res => {
        this.projectList = res.data.projectTbPage;
      });
    },
    remoteShop(params){
      params!==''&& this.searchShop(params)
    },
    searchShop(params){
      this.$axios
        .get("/shop/queryAll", { params: { projectId:this.queryProjectId,shopName:params } })
        .then(res => {
          this.shopList = res.data.shopTbPage;
      });
    },
    // 创建云纵
    addAlipay() {
      this.dialogFormVisible = true;
    },
    // 获取对应的商户
    getShop(value) {
      this.addWechatList.shopValue = ""; //清空商户input
      let projectId;
      this.projectList.forEach(item => {
        if (item.projectName === value) {
           this.queryProjectId = item.id;
        }
      });
    },
    // 确认创建
    addSureWechat() {
      let pjtId, shopId;
      if (JSON.parse(sessionStorage.getItem("user")).level === 1) {
        this.projectList.forEach(item => {
          if (item.projectName === this.addWechatList.projectValue) {
            pjtId = item.id;
          }
        });
        this.shopList.forEach(item => {
          if (item.shopName === this.addWechatList.shopValue) {
            shopId = item.id;
          }
        });
        // 如果是服务商层
      } else if (JSON.parse(sessionStorage.getItem("user")).level === 2) {
        this.shopList.forEach(item => {
          if (item.shopName === this.addWechatList.shopValue) {
            shopId = item.id;
          }
        });
        pjtId = JSON.parse(sessionStorage.getItem("user")).projectContractorId;
        // 如果是商户层
      } else {
        pjtId = JSON.parse(sessionStorage.getItem("user")).projectContractorId;
        shopId = JSON.parse(sessionStorage.getItem("user")).shopId;
      }
      if (
        this.addWechatList.mchName !== "" &&
        pjtId !== undefined &&
        shopId !== undefined
      ) {
        this.$axios
          .get("/mchyz/create", {
            params: {
              projectId: pjtId,
              shopId,
              mchName: this.addWechatList.mchName.trim()
            }
          })
          .then(res => {
            if (res.data.state === 1) {
              this.getAlipay(this.pageDatalist);
              this.DeleteSuccess();
              this.dialogFormVisible = false;
            } else {
              this.DeleteFailure();
            }
          });
        this.dialogFormVisible = false;
      } else {
        this.$message.error("请填写完整信息");
      }
      this.shopList = [];
      this.addWechatList.shopValue = ""; //清空input
      this.addWechatList.projectValue = "";
      this.addWechatList.mchName = "";
    },
    // 删除功能同微信
    DataDelete(row) {
      this.dialogVisibleDel = true;
      this.tabelData = row;
    },
    //确认删除
    SureDel() {
      const { id, shopId, projectContractorId } = this.tabelData;
      this.$axios
        .get("/mchyz/delete", {
          params: { mchId: id, shopId, projectId: projectContractorId }
        })
        .then(res => {
          if (res.data.state === 1) {
            this.getAlipay(this.pageDatalist);
            this.DeleteSuccess();
            this.dialogVisibleDel = false;
          } else {
            this.DeleteFailure();
          }
        });
    },
    //禁启用商户
    SwitchState(row) {
      const { projectContractorId, shopId, id } = row;
      if (row.Disable === "禁用") {
        this.$axios
          .get("mchyz/disable", {
            params: { projectId: projectContractorId, shopId, mchId: id }
          })
          .then(res => {
            if (res.data.state === 1) {
              this.getAlipay(this.pageDatalist);
              this.DeleteSuccess();
            }
          });
      } else if (row.Disable === "启用") {
        this.$axios
          .get("mchyz/enable", {
            params: { projectId: projectContractorId, shopId, mchId: id }
          })
          .then(res => {
            if (res.data.state === 1) {
              this.getAlipay(this.pageDatalist);
              this.DeleteSuccess();
            }
          });
      }
    },
    // 编辑
    DataEdit(row) {
      this.alipayList = { ...row };
      this.DataEdits = true;
    },
    // 确认编辑
    DetermineEdit() {
      const {
        id,
        shopId,
        yzMchId,
        projectContractorId,
        subMchId,
        mchName,
        examined,
        authorized
      } = this.alipayList;
      let authorizeds;
      if (authorized === "否") {
        authorizeds = 0;
      } else {
        authorizeds = 1;
      }
      if (mchName !== "") {
        this.$axios
          .get("/mchyz/edit", {
            params: {
              mchId: id,
              subMchId:subMchId.trim(),
              shopId,
              projectId: projectContractorId,
              mchName:mchName.trim(),
              yzMchId:yzMchId.trim(),
              examined,
              authorized: authorizeds
            }
          })
          .then(res => {
            if (res.data.state === 1) {
              this.getAlipay(this.pageDatalist);
              this.DeleteSuccess();
              this.DataEdits = false;
            } else {
              this.DeleteFailure();
            }
          });
      } else {
        this.$message.error("请填写完整信息");
      }
    },

    // 支付验证
    Verification(row) {
      this.payEdits = true;
      let data = {
        mchId: row.id,
        shopId: row.shopId,
        projectId: row.projectContractorId
      };
      this.$axios.get("/mchyz/payVerify", { params: data }).then(res => {
        if (res.data.state == 1) {
          this.payTotal = res.data.total / 100;
          this.tradeId.tradeId = res.data.trade_id;
          const url = res.data.url;
          new QRCode("payqrcodes", {
            width: 120,
            height: 120, // 高度
            correctLevel: 3,
            text: url, // 二维码内容
            render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
            background: "#f0f",
            foreground: "#ff0"
          });
        }
      });
    },
    //关闭二维码弹框
    closes() {
      document.querySelector("#payqrcodes").innerHTML = "";
      this.tradeId.tradeId = "";
    },
    // 时间转换
    getTiem(params) {
      let unixTimestamp = new Date(params * 1000); //时间戳转换成日期
      // 定义转换返回方式
      Date.prototype.toLocaleString = function() {
        return (
          this.getFullYear() +
          "年" +
          (this.getMonth() + 1) +
          "月" +
          +this.getDate() +
          "日" +
          " " +
          this.getHours() +
          "时" +
          this.getMinutes() +
          "分"
        );
      };
      params = unixTimestamp.toLocaleString();
      return params;
    },
    // 打款查询
    searchMoney(row) {
      this.MoneyRecord = [];
      this.dialogVisible = true;
      this.serachMoneyObj = { ...row };
      console.log(row)
    },
    // 确认查询
    confirmSearch() {
      const { id, projectContractorId, shopId } = this.serachMoneyObj;
      const { time } = this.formMoney;
      let paramsData = {
        mchId: id,
        projectId: projectContractorId,
        shopId,
        timeStamp: time / 1000
      };
      this.$axios.get("/mchyz/tCashQuery", { params: paramsData }).then(res => {
        if (res.data.state == 1) {
          this.$message({
            message: res.data.msg + "," + res.data.desc,
            showClose: true,
            type: "success"
          });
          let data = res.data.biz_content.datas.map(item=>{
            item.amount= item.amount/100;
            item.state=this.stateAll[item.state];
            return item
          });
          this.MoneyRecord = [...data,...this.MoneyRecord];
        } else {
          this.$message({
            message: res.data.msg + "," + res.data.desc,
            showClose: true,
            type: "error"
          });
        }
      });
    },
    //操作成功提示
    DeleteSuccess() {
      this.$message({
        message: "恭喜你，操作成功！",
        type: "success"
      });
    },
    //操作失败提示
    DeleteFailure() {
      this.$message.error("操作失败");
    },
    // 表格颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      }
      return "";
    }
  }
};
</script>

<style>
.el-table .warning-row {
  background: oldlace;
}


.el-table .cell {
  text-align: center;
}
#pag {
  position: fixed;
  bottom: 40px;
  right: 10px;
}

.el-col-4 {
  width: 13.66667%;
}
.el-button--mini {
  padding: 5px 5px;
}
.el-table td {
  padding: 10px 0;
}
#payqrcodes {
  width: 120px;
  height: 150px;
  margin: 10px auto 0;
}
.upDown {
  text-align: right;
  padding-right: 10px;
  color: red;
}
.upDown:hover {
  color: blue;
  cursor: pointer;
}
.el-select > .el-input {
  width: 93%;
}

.payMoney {
  margin: 0 auto 10px;
  text-align: center;
}
.payMoney > span {
  font-size: 16px;
  color: red;
}
</style>